import { FC } from 'react';
import { useIntl } from 'react-intl';
import { A11yButton } from '@fe-learner-common';
import { useEnrollmentFeedback } from '@hooks/feedback/useEnrollmentFeedback';
import { useSelfregSessionEnrollment } from '@routes/selfreg/hooks/useSelfregSessionEnrollment';
import { useEnrollmentError } from '@hooks/feedback/useEnrollmentError';

type JoinWaitlistButton = {
  sessionId: string;
};

export const JoinWaitlistButton: FC<JoinWaitlistButton> = ({ sessionId }) => {
  const intl = useIntl();

  const {
    mutate: enroll,
    data: enrollmentData,
    error,
    isPending,
  } = useSelfregSessionEnrollment({
    sessionId,
  });

  useEnrollmentError(error);
  useEnrollmentFeedback({
    enrollmentStatus: enrollmentData?.status,
    sessionId,
  });

  return (
    <A11yButton
      className="lf:l-btn lf:l-btn-md lf:l-btn-primary"
      isLoading={isPending}
      onClick={() => {
        enroll();
      }}
    >
      {intl.formatMessage({ id: 'catalog.course.waitlist.join' })}
    </A11yButton>
  );
};
